import * as React from 'react';
import { observer } from 'mobx-react';
import { PageStateItem } from './PageStateItem';
import './PageStateList.scss';
import { cs } from '@shared/utils/utils-classname';
import FlipMove from 'react-flip-move';
import { ISavedViewsFiles } from '../SavedViewsPanelComponent';

@observer
export class PageStateList extends React.Component<{
    isLoading: boolean;
    animate: boolean;
    noMenu?: boolean;
    focusedId: number;
    view?: 'thumbs' | 'list';
    items: IPageState[];
    onClick: (view: IPageState) => void;
    onEdit: (view: IPageState) => void;
    onUpdateState: (view: IPageState) => void;
    onDelete: (view: IPageState) => void;
    onDownload: (view: IPageState) => void;
    onExportBcf?: (view: IPageState) => void;
    onDetails: (view: IPageState) => void;
    onShare: (view: IPageState) => void;
    onOpenInOtherMap: (view: IPageState) => void;
    onLockToggle?: (view: IPageState) => void;
    models: ISavedViewsFiles;
    modelNames: Record<string, string>;
}> {
    render() {
        return (
            <>
                <FlipMove
                    staggerDurationBy={60}
                    maintainContainerHeight={false}
                    disableAllAnimations={!this.props.animate}
                    className={cs('saved-views__list', {
                        'fade-disable': this.props.isLoading,
                        'is-list': this.props.view === 'list',
                    })}
                >
                    {this.props.items.map(view => (
                        <PageStateItem
                            key={view.id}
                            item={view}
                            isFocused={this.props.focusedId == view.id}
                            view={this.props.view}
                            onClick={this.props.onClick}
                            noMenu={this.props.noMenu}
                            onEdit={this.props.onEdit}
                            onUpdateState={this.props.onUpdateState}
                            onDelete={this.props.onDelete}
                            onDetails={this.props.onDetails}
                            onShare={this.props.onShare}
                            onDownload={this.props.onDownload}
                            onExportBcf={this.props.onExportBcf}
                            onOpenInOtherMap={this.props.onOpenInOtherMap}
                            onLockToggle={this.props.onLockToggle}
                            models={this.props.models}
                            modelNames={this.props.modelNames}
                        />
                    ))}
                </FlipMove>
            </>
        );
    }
}
